/**
 * Build a nested object from a dot-separated path and value.
 * Example: buildNestedObject("user.profile.name", "John") => { user: { profile: { name: "John" } } }
 */
export function buildNestedObject(
  path: string,
  value: unknown
): Record<string, unknown> {
  if (!path) return {};
  const keys = path.split(".");

  return keys.reduceRight<Record<string, unknown>>(
    (acc, key, index) => ({ [key]: index === keys.length - 1 ? value : acc }),
    {}
  );
}
